export default __webpack_public_path__ + "static/media/hht2_sitcom_14.5849b676.png";